export enum VARIANT_TYPE {
  SUBSCRIPTION = 'subscription',
  SUBSCRIPTION_ADDON = 'subscriptionAddon',
  SINGLE = 'single'
}

export enum VARIANT_PERIOD_UNIT {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export enum VARIANT_PRICE_MODEL {
  PER_UNIT = 'perUnit',
  FIXED = 'fixed'
}

export enum VARIANT_STATUS {
  LIVE = 'live',
  DISABLED = 'disabled'
}

export interface Variant {
  id: number;
  title: string;
  status: VARIANT_STATUS | null;
  enabled: boolean | null;
  dateCreated: string | null;
  dateUpdated: string | null;
  displayInQuiz: boolean;
  variantType: VARIANT_TYPE;
  variantAmount: number;
  variantPeriod: number | null;
  variantRefGroup: string;
  variantShipping: false;
  externalRefPrice: string;
  variantPeriodUnit: VARIANT_PERIOD_UNIT | null;
  variantPriceModel: VARIANT_PRICE_MODEL;
  variantCustomTitle: string | null;
  variantMaxPurchaseQuantity: null;
  shippable?: boolean;
  variantLabel: string | null;
  variantPaymentAgreements: string | null;
  variantRecommended: boolean | null;
  // Multiselect only
  $isDisabled?: boolean;
  dosageCycleEnabled: boolean;
  dosageCycle: VariantDosageCycle;
  healthwarehouseProductId: number;
  dosageInstructionsEnabled: boolean;
  directions: VariantDosageDirections[]| null;
  pharmacyDosages: PharmacyDosages[]| null;
}

export interface VariantDosageCycle {
  title: string,
  cycleNumber: number,
  unitsDose: string,
  directions: string,
}

export interface VariantDosageDirections {
  col1: string;
}

export interface PharmacyDosages {
  col1: string;
  col2: string;
}
